import FlexTable from './FlexTable';

export default FlexTable;
